// TodayTab に置く「今日の宇宙のひとこと」枠。五つのテーマから日替わりで一つだけ出し、タップで詳細ページへ
import React from 'react';
import type { UserLocation } from '../../lib/userLocation';
import { useCosmosData } from './useCosmosData';
import { buildThemes, pickDailyTheme, pendingThemes } from './themes';
import { dailyPractice } from './practice';

export default function CosmosCard({ dateKey, loc, onOpen }: {
  dateKey?: string;
  loc: UserLocation | null | undefined; // undefined=確認中, null=位置なし
  onOpen?: () => void;                  // 詳細ページを開く
}) {
  const data = useCosmosData(loc, dateKey);
  const themes = buildThemes(data);
  const theme = pickDailyTheme(themes, data.now, pendingThemes(data));

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="今日の宇宙のひとこと。タップで全テーマを見る"
      style={{
        display: 'block', width: '100%', textAlign: 'left', cursor: onOpen ? 'pointer' : 'default',
        background: 'linear-gradient(135deg,#1e1b4b,#0f172a)',
        borderRadius: '14px', border: '1px solid #C9A84C', padding: '14px',
        marginBottom: '14px', color: '#f8fafc', font: 'inherit',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '8px', marginBottom: '8px' }}>
        <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#e8c96a', letterSpacing: '1px', fontFamily: "'Shippori Mincho', serif" }}>
          🌌 今日の宇宙のひとこと
        </div>
        {theme && <div style={{ fontSize: '12px', color: '#cbd5e1' }}>{theme.label}</div>}
      </div>

      {theme ? (
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <div style={{ fontSize: '36px', lineHeight: 1, width: '40px', textAlign: 'center' }}>{theme.icon}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '15px', lineHeight: 1.8, fontFamily: "'Noto Serif JP', serif" }}>{theme.headline}</div>
            {theme.lines[0] && <div style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px', lineHeight: 1.6 }}>{theme.lines[0]}</div>}
            {theme.notes[0] && <div style={{ fontSize: '12px', color: '#e8c96a', marginTop: '2px', lineHeight: 1.6 }}>{theme.notes[0]}</div>}
          </div>
        </div>
      ) : (
        <div style={{ fontSize: '13px', color: '#cbd5e1', padding: '8px 0' }}>今日の宇宙の様子を確かめています…</div>
      )}

      {theme && (
        <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '0.5px solid #C9A84C55', fontSize: '13px', lineHeight: 1.8, color: '#f1f5f9' }}>
          <span style={{ color: '#e8c96a', fontWeight: 'bold' }}>🧘 一日一分　</span>{dailyPractice(theme.key, data.now)}
        </div>
      )}

      {onOpen && (
        <div style={{ textAlign: 'right', fontSize: '12px', color: '#e8c96a', marginTop: '8px' }}>
          月・太陽・宇宙天気・夜空・地球をすべて見る ›
        </div>
      )}
    </button>
  );
}
